import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { colorVariables } from 'desktop/theme/variables';
import {
  ProgramStyled,
  RightPart,
  LeftPart,
  Current,
  RecordWrap,
  Time,
  LastWordWrap,
  TitleWrap,
  StyledTime,
  StyledTitle,
  StyledIcon,
} from './styles/ProgramStyled';

class Program extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.timeout = undefined;
  }

  componentDidMount() {
    this.props.onInstance(this.props.index, this);
  }

  componentWillUnmount() {
    this.props.onInstance(this.props.index, null);
  }

  onClickProgram = () => {
    const { playing, singleProgram, switchProgram } = this.props;

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = undefined;
      if (!playing) {
        this.props.toggleExpand();
        switchProgram(singleProgram, true);
      }
    } else {
      this.timeout = setTimeout(() => {
        switchProgram(singleProgram, true);
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }, 200);
    }
  };

  render() {
    const {
      time,
      title,
      available,
      playing,
      ended,
      current,
      id,
      style,
      index,
      isInteractive,
    } = this.props;
    const date = new Date(id * 1000);
    let programTitle = title;
    let lastWord = null;

    if (available) {
      const lastSpace = programTitle.lastIndexOf(' ');
      if (lastSpace !== -1) {
        lastWord = title.substring(lastSpace + 1, title.length);
        programTitle = title.substring(0, lastSpace);
      }
    }

    return (
      <ProgramStyled
        onClick={available ? this.onClickProgram : null}
        id={id}
        style={style}
        data-name="program"
        data-day={date.getDate()}
        data-month={date.getMonth()}
        data-index={index}
        available={available}
      >
        <LeftPart>
          {current && <Current />}
          <Time>
            <StyledTime
              currentLineal={!isInteractive && current}
              playing={playing}
              available={available}
              color={colorVariables.gray_darksmoke}
              size="fs_l"
              ended={ended}
            >
              {time}
            </StyledTime>
          </Time>
        </LeftPart>
        <RightPart>
          <TitleWrap>
            <StyledTitle
              currentLineal={!isInteractive && current}
              playing={playing}
              available={available}
              size="fs_l"
              ended={ended}
            >
              {programTitle}
              {lastWord && <Fragment>&nbsp;</Fragment>}
              {available && (
                <LastWordWrap>
                  {lastWord}
                  <RecordWrap available={available}>
                    <StyledIcon
                      available={available}
                      name="play"
                      size={8}
                      color={colorVariables.orange}
                    />
                  </RecordWrap>
                </LastWordWrap>
              )}
            </StyledTitle>
          </TitleWrap>
        </RightPart>
      </ProgramStyled>
    );
  }
}

Program.propTypes = {
  time: PropTypes.string.isRequired,
  title: PropTypes.string,
  ended: PropTypes.bool,
  available: PropTypes.bool,
  playing: PropTypes.bool,
  current: PropTypes.bool,
  switchProgram: PropTypes.func,
  singleProgram: PropTypes.object,
  id: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
  onInstance: PropTypes.func.isRequired,
  toggleExpand: PropTypes.func,
  isInteractive: PropTypes.bool,
};

Program.defaultProps = {
  title: '',
  available: false,
  playing: false,
  ended: false,
  current: false,
  switchProgram: Function.prototype,
  singleProgram: {},
  toggleExpand: Function.prototype,
  isInteractive: false,
};

export default Program;
